module.exports = __webpack_public_path__ + "static/media/greenday3.aee52f46.mp4";